// extracted by mini-css-extract-plugin
module.exports = {"loading_spinner":"styles_loading_spinner__2K2TV","spinner":"styles_spinner__2_dtX"};